var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.243 6.20625C4.62903 6.59687 5.25594 6.59687 5.64197 6.20625L9.59491 2.20625C9.87903 1.91875 9.96241 1.49062 9.808 1.11562C9.65359 0.740622 9.29535 0.496872 8.89388 0.496872L0.988001 0.499997C0.589619 0.499997 0.228296 0.743747 0.0738837 1.11875C-0.080528 1.49375 0.00594255 1.92187 0.286972 2.20937L4.23991 6.20937L4.243 6.20625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.443dabe87126250d08b7a6cab2b737aa.svg";
export { ForwardRef as ReactComponent };